import { useFormik } from 'formik';
import * as yup from 'yup';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, Grid, TextField } from '@mui/material';

import { CollateralItemState } from '@/types';
import { useCreateCollateralItemStateMutation } from '@/services';
import { messages } from '@/utils/helpers';

export interface CreateCollateralItemStateProps extends DialogProps {
  onClose(): void;
}

const CreateCollateralItemState: React.FC<CreateCollateralItemStateProps> = ({ onClose, ...props }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [createCollateralItemState, createCollateralItemStateResponse] = useCreateCollateralItemStateMutation();

  const { values, touched, errors, handleChange, handleSubmit } = useFormik<CollateralItemState>({
    initialValues: {
      name: '',
      gkd_code: '',
    },
    validationSchema: yup.object().shape({
      name: yup.string().required(messages.form.REQUIRED),
      gkd_code: yup.string().required(messages.form.REQUIRED),
    }),
    async onSubmit(сollateralItemState, { resetForm }) {
      try {
        await createCollateralItemState(сollateralItemState).unwrap();

        onClose();
        resetForm();
      } catch (error) {
        enqueueSnackbar(error.data, { variant: 'error' });
      }
    },
  });

  return (
    <Dialog fullWidth {...props}>
      <DialogTitle fontWeight="bold">Добавить характеристику</DialogTitle>

      <form onSubmit={handleSubmit}>
        <DialogContent dividers>
          <Grid container spacing={3}>
            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="name"
                label="Наименование"
                placeholder="Введите значение"
                value={values.name}
                onChange={handleChange}
                disabled={createCollateralItemStateResponse.isLoading}
                error={touched.name && Boolean(errors.name)}
                helperText={touched.name ? errors.name : ''}
                fullWidth
              />
            </Grid>

            <Grid item lg={6} md={6} xs={12}>
              <TextField
                name="gkd_code"
                label="Код"
                placeholder="Введите значение"
                value={values.gkd_code}
                onChange={handleChange}
                disabled={createCollateralItemStateResponse.isLoading}
                error={touched.gkd_code && Boolean(errors.gkd_code)}
                helperText={touched.gkd_code ? errors.gkd_code : ''}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            type="button"
            color="secondary"
            variant="outlined"
            size="large"
            disabled={createCollateralItemStateResponse.isLoading}
            onClick={onClose}
          >
            Закрыть
          </Button>

          <Button type="submit" variant="contained" size="large" disabled={createCollateralItemStateResponse.isLoading}>
            Добавить
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateCollateralItemState;
